export default __webpack_public_path__ + "db24ee950c3fd6a3017256a4b2c9fdc0.png";